import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=440d4432&scoped=true"
import script from "./academic.vue?vue&type=script&setup=true&lang=js"
export * from "./academic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./academic.vue?vue&type=style&index=0&id=440d4432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440d4432",
  null
  
)

export default component.exports